import {
  pullOptions,
  pushOptions,
} from "../views/coaching-portal/custom-workflows/data/getting-started";
import i18n from "../i18n";

const CustomWorkflows = (app) => {
  app
    .post(
      "/custom-workflows/getting-started/create",
      async ({ res, flash, api, req }) => {
        const access = req.body.access ?? "push";
        const body = {
          type: "getting-started",
          status: "draft",
          access,
          options: access === "push" ? pushOptions : pullOptions,
        };

        await api("workflow", {
          method: "POST",
          body,
        });

        flash(
          "success",
          i18n.t("coaching-portal:customWorkflowsActions.successfullyCreated")
        );
        res.backDontScroll();
      }
    )
    .get(
      "/custom-workflows/publish/:id",
      async ({ api, assert, res, req, flash }) => {
        const { id } = req.params;
        assert(
          id,
          400,
          i18n.t("coaching-portal:customWorkflowsActions.workflowIdRequired")
        );

        try {
          await api(`workflow/${id}`, {
            method: "PUT",
            body: { status: "published" },
          });
          flash(
            "success",
            i18n.t("coaching-portal:customWorkflowsActions.successfullyPublished")
          );
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .get(
      "/custom-workflows/unpublish/:id",
      async ({ api, assert, res, req, flash }) => {
        const { id } = req.params;
        assert(
          id,
          400,
          i18n.t("coaching-portal:customWorkflowsActions.workflowIdRequired")
        );

        try {
          await api(`workflow/${id}`, {
            method: "PUT",
            body: { status: "draft" },
          });
          flash(
            "success",
            i18n.t(
              "coaching-portal:customWorkflowsActions.successfullyUnpublished"
            )
          );
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/custom-workflows/set-published-at/:id",
      async ({ api, assert, res, req, flash }) => {
        const { id } = req.params;
        const { publishedAt } = req.body;
        assert(id, 400, "Workflow ID is required");

        try {
          await api(`workflow/${id}`, {
            method: "PUT",
            body: { publishedAt: publishedAt ? new Date(publishedAt) : null },
          });
          flash("success", "Effective start date updated");
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    );
};

export default CustomWorkflows;
